export default __webpack_public_path__ + "img/911cd5bcc9eb9ca829713b7188df308a.svg";